const latlng = {
    getLatitude(data) {
        return +(data.latitude || data.lat || data[1]);
    },
    getLongitude(data) {
        return +(data.longitude || data.lng || data.lon || data[0]);
    },
    isLatlngAvailable(lat, lng) {
        return !isNaN(lat) && !isNaN(lng) && lat && lng;
    },
    format(data) {
        let lat = latlng.getLatitude(data),
            lng = latlng.getLongitude(data);
        return this.isLatlngAvailable(lat, lng) ? lat + '-' + lng : null;
    },
    generateDataByLatlng(list) {
        let hash = {};
        if (list && list.length) {
            list.forEach(item => {
                let latlngStr = latlng.format(item);
                if (hash[latlngStr]) {
                    hash[latlngStr].items.push(item);
                } else if (latlngStr) {
                    hash[latlngStr] = {
                        lat: latlng.getLatitude(item),
                        lng: latlng.getLongitude(item),
                        items: [item]
                    };
                }
            });
        }
        return Object.values(hash);
    },
    iterateLocation(list, callback) {
        const len = list.length;
        for (let i = 0; i < len; i++) {
            const data = list[i];
            if (!data) {
                continue; 
            }
            const lat = latlng.getLatitude(data);
            const lng = latlng.getLongitude(data);
            if (!latlng.isLatlngAvailable(lat, lng)) {
                continue;
            }
            callback(lat, lng, i, data);
        }
    }
};

export default latlng;
